/* eslint-disable max-len */
function drawTierBox(data, price) {
  const ele = document.createElement('div');
  ele.classList.add('tierBoxes', 'nFlex');

  data.forEach((item) => {
    const tierQty = item.quantity;
    const tierPrice = item.price;
    const discount = 100 - (Math.ceil((parseFloat(tierPrice.substring(1)) / parseFloat(price.substring(1))) * 100));

    ele.insertAdjacentHTML('beforeend', `<div class="tierBox"><span class="tierQty">${tierQty}</span><span class="tierPrice">${tierPrice}</span><span class="tierDiscount">${discount}%</span></div>`);
  });

  // ele.insertAdjacentHTML('afterbegin', '<div class="tierBox"><span class="tierQty">Quantity</span><span class="tierPrice">Price</span><span class="tierDiscount">Savings</span></div>');

  // ele.querySelectorAll('.tierBox').forEach((b) => {
  //   const tbQty = b.querySelector('.tierQty');
  //   const nextQty = b.nextSibling ? b.nextSibling.querySelector('.tierQty').textContent : '';
  //   const currentQty = tbQty.textContent;
  //   if (nextQty === '') {
  //     tbQty.insertAdjacentHTML('beforeend', '+');
  //   } else if (parseInt(nextQty, 10) !== (parseInt(currentQty, 10) + 1)) {
  //     tbQty.insertAdjacentHTML('beforeend', `-${nextQty - 1}`);
  //   }
  // });

  ele.insertAdjacentHTML('afterbegin', '<div class="tierBox"><span class="tierQty">Qty</span><span class="tierPrice">Price</span><span class="tierDiscount">Discount</span></div></div>');

  return ele;
}

const tierPricingFunction = (pdp = false, plp = false, showLowestPrice = false) => {
  if (document.querySelector('.ex-product')) {
    const hasTiers = document.querySelectorAll('.product-shopping-actions .product-shopping-actions-tierpricing');
    if (pdp === false) return;
    if (hasTiers) {
      const tierPricingData = document.querySelector('.desktop .softgraybackground .product-shopping-actions-tierpricing')?.getAttribute('data-tierpricing') || '';
      if (!tierPricingData.length) return;

      if (document.querySelector('.product-shopping-actions .tierBoxes')) return;

      const data = JSON.parse(tierPricingData);

      hasTiers.forEach((item) => {
        const price = item.closest('.product-shopping-actions').querySelector('.has-price[data-value]');
        item.after(drawTierBox(data, price.innerHTML));

        const tierBoxes = item.parentNode.querySelector('.tierBoxes');
        const wrapper = document.createElement('div');
        wrapper.className = 'col-md-12';
        tierBoxes.parentNode.insertBefore(wrapper, tierBoxes);
        wrapper.appendChild(tierBoxes);

        // show lowest price above main
        if (showLowestPrice) {
          const tierLowestPrice = data.reduce((prev, current) => {
            const prevPrice = parseFloat(prev.price.replace(/[^\d.-]/g, ''));
            const currentPrice = parseFloat(current.price.replace(/[^\d.-]/g, ''));
            return prevPrice < currentPrice ? prev : current;
          });
          price.insertAdjacentHTML('beforebegin', `<div class="lowestPrice">${tierLowestPrice.price}</div>`);
          price.style.display = 'none';
        }
      });
    }
  } else {
    if (plp === false) return;
    document.querySelectorAll('.productsgrid_container div.product').forEach((item) => {
      if (item.querySelector('.tierBoxes')) return;

      const hasTiers = item.querySelector('.product-shopping-actions-tierpricing');
      if (hasTiers) {
        const tierPricingData = item.querySelector('.product-shopping-actions-tierpricing')?.getAttribute('data-tierpricing');
        if (!tierPricingData.length) return;

        const data = JSON.parse(tierPricingData);

        hasTiers.after(drawTierBox(data, item.querySelector('.has-price').innerHTML.trim()));

        // show lowest price above main
        if (showLowestPrice) {
          const tierLowestPrice = data.reduce((prev, current) => {
            const prevPrice = parseFloat(prev.price.replace(/[^\d.-]/g, ''));
            const currentPrice = parseFloat(current.price.replace(/[^\d.-]/g, ''));
            return prevPrice < currentPrice ? prev : current;
          });
          item.querySelector('.has-price').insertAdjacentHTML('beforebegin', `<div class="lowestPrice">${tierLowestPrice.price}</div>`);
          item.querySelector('.has-price').style.display = 'none';
        }
      }
    });
    window.dispatchEvent(new Event('resize'));
  }
};

// export to separate pdp file if needed
// window.evoXProductChangeCallback = () => {
//   runTierPricing();
// };
export default tierPricingFunction;

const runTierPricing = () => {
  tierPricingFunction(true, false, false);
};

// edits need to me made after live loading
function checkLoad() {
  if (document.body.classList.contains('has-live-pricing')) {
    document.addEventListener('live-pricing-done', () => {
      console.log('live pricing has just finished running');
      runTierPricing();
    }, false);
  } else {
    runTierPricing();
  }
}

checkLoad();

if (document.body.classList.contains('has-live-pricing')) {
  document.addEventListener('live-pricing-done', () => {
    console.log('live pricing has just finished running');
    runTierPricing();
  }, false);
} else {
  document.addEventListener('product-loadmore-success', (e) => {
    console.log('More products loaded', e.detail);
    runTierPricing();
  }, false);
}
